import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';

export const useDepotsNavegacao = () => {
  const history = useHistory();

  const handleRowClick = useCallback(
    (row) => {
      const rowId = row?.id ?? row?.original?.id;
      if (!rowId) return;

      history.push(`/pages/containers/programacao/detalhesdepots/${rowId}`);
    },
    [history],
  );

  const handleAdicionar = useCallback(() => {
    history.push('/pages/containers/programacao/criar');
  }, [history]);

  const handleEditar = useCallback(
    (id) => {
      if (!id) return;
      history.push(`/pages/containers/programacao/editar/${id}`);
    },
    [history],
  );

  return {
    handleRowClick,
    handleAdicionar,
    handleEditar,
  };
};
